import parsePhoneNumber from 'libphonenumber-js';
import { matchIsValidTel } from 'mui-tel-input';

export const formatPhone = (phone: string): string => {
  const parsedPhoneNumber = parsePhoneNumber(phone, 'US');
  // istanbul ignore next
  return parsedPhoneNumber
    ? parsedPhoneNumber?.formatNational()
    : phone.replace(
        /(\+?)(\d{3})(\d{3})(\d{4})/gi,
        (_match, _plus, p1, p2, p3) => `(${p1}) ${p2}-${p3}`
      );
};

export const isValidPhoneNumber = (phoneNumber: string) =>
  matchIsValidTel(phoneNumber);
